import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Typography
} from "@mui/material";
import { authenticationService } from "src/services";
import { put } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

/* =========================
   Props
========================= */
interface UpdateZoneProps {
  handleClose: () => void;
  Zoneidvalues: any;
  fetchZones: () => void;
}

const UpdateZone: React.FC<UpdateZoneProps> = ({
  handleClose,
  Zoneidvalues,
  fetchZones
}) => {
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { showSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    id: 0,
    name: "",
    isActive: true,
    vendorId: vendorId
  });

  /* =========================
     Prefill Zone Data
  ========================= */
  useEffect(() => {
    if (Zoneidvalues) {
      setForm({
        id: Zoneidvalues.id,
        name: Zoneidvalues.name || "",
        isActive: Zoneidvalues.isActive,
        vendorId: vendorId
      });
    }
  }, [Zoneidvalues, vendorId]);

  /* =========================
     Handlers
  ========================= */
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.name) {
      showSnackbar("Zone name is required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        id: form.id,
        name: form.name,
        isActive: form.isActive,
        vendorId: form.vendorId
      };

      const response = await put(
        `${APIURL}/api/miscellaneous/zone`,
        payload
      );

      if (response?.statusCode === 200) {
        showSnackbar(
          response?.message || "Zone updated successfully",
          "success"
        );
        fetchZones();
        handleClose();
      } else {
        showSnackbar(
          response?.message || "Failed to update zone",
          "error"
        );
      }
    } catch (error: any) {
      showSnackbar(error?.message || "Failed to update zone", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Update Zone
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Zone Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={e =>
                  setForm(prev => ({
                    ...prev,
                    isActive: e.target.checked
                  }))
                }
              />
            }
            label="Is Active"
          />
        </Grid>

        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdateZone;
